export function formatCurrency(value: string) {
  if (!value) return '';

  return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
